export default "__VITE_ASSET__hyT2sklF__"